"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("./constants");
var _styles = require("./styles");
var _tableClasses = require("./tableClasses");
var _jsxRuntime = require("react/jsx-runtime");
const Table = ({
  columns,
  data,
  ariaLabel,
  className,
  getRowKey,
  tableProps
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const getRowKeyInternal = (0, _react.useCallback)((row, index) => {
    if (typeof getRowKey === 'function') {
      return getRowKey(row);
    }
    if (typeof getRowKey === 'string') {
      return String(row[getRowKey]);
    }
    return `row-${index}`;
  }, [getRowKey]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TableContainer, {
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledTable, {
      size: "small",
      "data-testid": getTestId(_constants.TABLE),
      "aria-label": ariaLabel,
      ...tableProps,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TableHead, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TableRow, {
          children: columns.map(({
            accessorKey,
            header,
            maxWidth,
            minWidth,
            maxHeaderLines,
            headerProps
          }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledHeaderCell, {
            "data-testid": getTestId(_constants.TABLE_HEADER),
            align: "center",
            minWidth: minWidth,
            maxWidth: maxWidth,
            scope: "col",
            className: _tableClasses.tableClasses.headerCell,
            ...headerProps,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HeaderCell, {
              fontWeight: "bold",
              className: _tableClasses.tableClasses.headerText,
              maxLines: maxHeaderLines,
              children: header
            })
          }, String(accessorKey)))
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.TableBody, {
        children: data.map((row, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTableRow, {
          "data-testid": getTestId(_constants.TABLE_ROW),
          children: columns.map(({
            accessorKey,
            align,
            Cell,
            maxWidth,
            minWidth,
            maxItemLines,
            cellProps
          }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledItemCell, {
            align: align ?? 'center',
            minWidth: minWidth,
            maxWidth: maxWidth,
            className: _tableClasses.tableClasses.itemCell,
            ...cellProps,
            children: Cell ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Cell, {
              row: row
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ItemCell, {
              className: _tableClasses.tableClasses.itemText,
              maxLines: maxItemLines,
              children: String(row[accessorKey])
            })
          }, String(accessorKey)))
        }, getRowKeyInternal(row, index)))
      })]
    })
  });
};
exports.Table = Table;
//# sourceMappingURL=Table.js.map